import React, { useEffect, useRef } from 'react';

export default function WebpagesPageContextMenu({ x, y, page, onClose, onAction }) {
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, [onClose]);

  if (!page) return null;

  const items = [
    { label: 'Copy', icon: 'fa fa-copy', action: 'copy' },
    { label: 'Cut', icon: 'fa fa-cut', action: 'cut' },
    { label: 'Duplicate', icon: 'fa fa-clone', action: 'duplicate' },
    { separator: true },
    { label: 'Browse', icon: 'ti-eye', action: 'browse' },
    { label: 'Edit', icon: 'fa fa-file-text-o', action: 'edit' },
  ];

  return (
    <div
      className="z-50 py-1 bg-white border rounded-md shadow-lg border-slate-200"
      style={{
        position: 'fixed',
        top: y,
        left: x,
        minWidth: '160px',
      }}
      ref={ref}
    >
      {items.map((item, idx) => (
        <div key={idx}>
          {item.separator ? <div className="h-px my-1 bg-slate-200"></div> : null}
          {!item.separator ? (
            <button
              type="button"
              className="flex items-center w-full gap-2 px-4 py-2 text-sm text-left cursor-pointer text-slate-700 hover:bg-slate-50"
              onClick={() => {
                onAction(item.action, page);
                onClose();
              }}
            >
              <i className={`${item.icon} text-slate-400 w-5`}></i> {item.label}
            </button>
          ) : null}
        </div>
      ))}
    </div>
  );
}
